export const mapBackendToForm = (data) => {
  if (!data) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 16);
  };

  return {
    ...data,
    instruction_date: formatDate(data.instruction_date),
    blood_investigation_date: formatDate(data.blood_investigation_date),
    motor_sensory_regression: formatDateTime(data.motor_sensory_regression),
    concentration_date_time: formatDateTime(data.concentration_date_time),
    blood_investigation_time: data.blood_investigation_time?.slice(0, 5) || "",
    inj_paracetamol_time: data.inj_paracetamol_time?.slice(0, 5) || "",
    inj_ukat_time: data.inj_ukat_time?.slice(0, 5) || "",
  };
};

export const mapFormToBackend = (formData) => {
  const formatDateTime = (input) => {
    if (!input) return null;
    const date = new Date(input);
    if (isNaN(date)) return null;
    return date.toISOString().slice(0, 19).replace("T", " ");
  };

  const formatDate = (input) => {
    if (!input) return null;
    const date = new Date(input);
    if (isNaN(date)) return null;
    return date.toISOString().slice(0, 10);
  };

  const formatTime = (input) => {
    if (!input) return null;
    return `${input}:00`;
  };

  return {
    ...formData,
    instruction_date: formatDate(formData.instruction_date),
    blood_investigation_date: formatDate(formData.blood_investigation_date),
    blood_investigation_time: formatTime(formData.blood_investigation_time),
    concentration_date_time: formatDateTime(formData.concentration_date_time),
    motor_sensory_regression: formatDateTime(formData.motor_sensory_regression),
    inj_paracetamol_time: formatTime(formData.inj_paracetamol_time),
    inj_ukat_time: formatTime(formData.inj_ukat_time),
  };
};
